import React, { useEffect } from "react";
import { Root, Auth } from "../routing";
import { useAppDispatch, useAppSelector } from "./../redux/hooks";
import { SelectAuth, selectAuthToken, selectIsLoading, selectIsLogin, SetToken } from "./redux/slice";
import { getAuthToken } from "./redux/thunk";
import {
  setInLocalStorage,
  getFromLocalStorage,
  asynchronouslyGetFromLocal,
} from "./../utils/helperFunctions";
import axios from "axios";
import Cookies from "js-cookie";


const Layout = () => {
  const dispatch = useAppDispatch();
  const selectLayout = useAppSelector(selectAuthToken);
  const selectLogin = useAppSelector(selectIsLogin);
  const isLoading = useAppSelector(selectIsLoading);
  const getAuthToken = Cookies.get("token");

  useEffect(() => {
    if (selectLayout !== null) {
      const token = selectLayout;
      setInLocalStorage("D_APP_TOKEN", token);
    }
  }, [selectLayout]);


  const checkAuth = async () => {
    const user = Cookies.get("token");
    if (user) {
      dispatch(SetToken({ token: user }));
      dispatch(SelectAuth(user));
    } else {
      dispatch(SelectAuth(null));
    }
  };

  useEffect(() => {
    checkAuth();
  }, [Cookies.get("token")]);

  const renderRouting = (isAuth) => {
    switch (isAuth) {
      case true:
        return <Root />;
      case false:
        return <Auth />;
      default:
        return <Auth />;
    }
  };

  // useEffect(() => {
  //   if (getAuthToken == "undefined" || getAuthToken == undefined) {
  //     window.location.href = "/login"
  //   }
  // }, [])

  const dynamicClass =
    window.location.pathname === "/thanks-availability" || window.location.pathname === "/calendly-availability"
      ? "thanks-availability"
      : "";


  useEffect(() => {
    if (window.location.pathname == "/signup-number") {
      Cookies.remove('token')
    }
  }, [])

  return (
    <>
      {isLoading !== null && isLoading ? (
        <div className="loading"></div>
      ) : (
        <div className={`_layout_wrapper ${dynamicClass}`}>{renderRouting(selectLogin)}</div>
      )}
    </>
  );
};

export default Layout;
